module.exports = __webpack_public_path__ + "media/country_flags/sk-d182b583.png";